import { render, staticRenderFns } from "./ImportantReminders.vue?vue&type=template&id=e19d4810&scoped=true"
import script from "./ImportantReminders.vue?vue&type=script&lang=js"
export * from "./ImportantReminders.vue?vue&type=script&lang=js"
import style0 from "./ImportantReminders.vue?vue&type=style&index=0&id=e19d4810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19d4810",
  null
  
)

export default component.exports